import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

import {isMeCoachForEntity} from '../isMeCoachForEntity';

export const isConferenceConflicting = (
  conference?: Nullable<ConferenceApiModel>,
) =>
  isMeCoachForEntity(conference) &&
  conference?.booking?.status === 'conflicting';
